export default "__VITE_ASSET__DX1D7Bza__"